import { inject, Injectable } from '@angular/core';
import { BASE_URL_TOKEN } from '../../../core/injection-tokens/base-url.token';
import { HttpClient } from '@angular/common/http';
import { FilterApiService } from '../filterApi/filter-api.service';
import { Observable } from 'rxjs';
import { IChatDetails, IChatMessage, IChatsListItem, IFilter, IPagingResponse, IResponse, ISendMessage } from '../../../core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ChatsApiService {
  private baseUrl = inject(BASE_URL_TOKEN);
  private path = 'chats'
  private http = inject(HttpClient)
  private filter = inject(FilterApiService);

  getChats(filter: IFilter): Observable<IPagingResponse<IChatsListItem[]>> {
    return this.filter.getFilteredData(`${this.baseUrl}/${this.path}/getAllChats`, filter);
  }
  getChatDetails(userId: number | null, postId?: number | null): Observable<IResponse<IChatDetails>> {
    return this.http.get<IResponse<IChatDetails>>(`${this.baseUrl}/${this.path}/getChatDetails/${userId}?postId=${postId}`);
  }
  getChatMessages(filter: IFilter, chatId: number): Observable<IPagingResponse<IChatMessage[]>> {
    return this.filter.getFilteredData(`${this.baseUrl}/${this.path}/getChatMessages/${chatId}`, filter);
  }
  sendMessage(data: ISendMessage, chatId: number): Observable<IResponse<IChatMessage>> {
    return this.http.post<IResponse<IChatMessage>>(`${this.baseUrl}/${this.path}/sendMessage/${chatId}`, data)
  }
}
